import { PortalDayFragment, usePortalPeriodSignMutation } from "@dashboard/graphql";
import { Box, Button, Text, Textarea } from "@saleor/macaw-ui-next";
import { useState } from "react";
import { useIntl } from "react-intl";

import { ErrorText, Section } from "./components";
import { portalMessages as m } from "./messages";
import { SignaturePad } from "./SignaturePad";
import { formatDay, formatMinutes } from "./utils";

/** Daily rubrica, once the day is closed. */
export const DailySign = ({ day, onDone }: { day: PortalDayFragment; onDone: () => void }) => {
  const intl = useIntl();
  const [agreed, setAgreed] = useState<boolean | null>(null);
  const [note, setNote] = useState("");
  const [drawing, setDrawing] = useState<string | null>(null);
  const [sign, signOpts] = usePortalPeriodSignMutation({
    onCompleted: data => {
      if (!data.periodSign?.errors.length) {
        onDone();
      }
    },
  });

  return (
    <Section title={`${intl.formatMessage(m.signDay)} · ${formatDay(day.date)}`}>
      <Text size={3}>
        {intl.formatMessage(m.registered)}: <b>{formatMinutes(day.workedMinutes)}</b>
        {day.dispensationMinutes > 0 &&
          ` · ${intl.formatMessage(m.dispensation)}: ${formatMinutes(day.dispensationMinutes)}`}
      </Text>
      <Box display="flex" gap={2} flexWrap="wrap">
        <Button variant={agreed === true ? "primary" : "secondary"} onClick={() => setAgreed(true)}>
          {intl.formatMessage(m.agree)}
        </Button>
        <Button
          variant={agreed === false ? "primary" : "secondary"}
          onClick={() => setAgreed(false)}
        >
          {intl.formatMessage(m.disagree)}
        </Button>
      </Box>
      {agreed === false && (
        <Textarea
          rows={2}
          maxLength={4000}
          label={intl.formatMessage(m.signNote)}
          value={note}
          onChange={event => setNote(event.target.value)}
        />
      )}
      <SignaturePad onChange={setDrawing} />
      <Box>
        <Button
          variant="primary"
          disabled={
            agreed === null || (agreed === false && !note.trim()) || !drawing || signOpts.loading
          }
          onClick={() =>
            sign({
              variables: {
                start: day.date,
                end: day.date,
                agreed: agreed === true,
                note: note.trim(),
                drawing: drawing ?? "",
              },
            })
          }
        >
          {intl.formatMessage(m.signDay)}
        </Button>
      </Box>
      <ErrorText errors={signOpts.data?.periodSign?.errors} />
    </Section>
  );
};
